var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "address-ctas" }, [
    _c("div", { staticClass: "address-add" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.active,
              expression: "!active",
            },
          ],
          staticClass: "address-add__button",
          on: { click: _vm.show },
        },
        [_vm._v("+ Add New Address")]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active,
              expression: "active",
            },
          ],
          staticClass: "address-form",
        },
        [_vm._t("default")],
        2
      ),
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.active && _vm.hasActiveSubs,
              expression: "!active && hasActiveSubs",
            },
          ],
          staticClass: "address-add__button",
          attrs: { href: "/tools/recurring/login" },
        },
        [_vm._v("+/- Manage Subscription Addresses")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }